import React, { useState } from "react";
import { Grid } from "@mui/material";
import { useAuth } from "src/components/providers/auth-context";
import request from "src/utils/request";
import { useActiveIntegrations } from "src/scenes/dashboard/active-integrations-provider";
import PersonalSummary from "src/scenes/dashboard/overview-components/personal-summary";
import QuestionsSection from "src/scenes/dashboard/overview-components/questions-section";
import IndexesSection from "src/scenes/dashboard/overview-components/indexes-section";
import useOverviewApi from "src/scenes/dashboard/hooks/use-overview-api";
import questionsMockData from "src/scenes/dashboard/overview-components/questions-mock-data";
import IndexesOptInPlaceholder from "src/components/indexes-opt-in-placeholder";

const Insights = () => {
    const [indexesOptedIn, setIndexesOptedIn] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isPersonalSummaryVisible, setIsPersonalSummaryVisible] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = React.useState();
    const [summaryData, setSummaryData] = useState([]);
    const { isDemo } = useAuth();
    const OverviewApi = useOverviewApi("overview");
    const { activeIntegrations } = useActiveIntegrations();
    const latestReadSummaryDate = localStorage.getItem("readSummary");
    const isTeams = false;

    const questions = questionsMockData;
    const getLatestSummary = async () => {
        try {
            let response;
            if (isDemo) {
                response = (await import("src/scenes/summary/summary-mock-data")).default;
            } else {
                response = await request(`/api/users/me/summary`, {
                    method: "GET",
                });
            }
            setSummaryData(response);
        } catch (error) {
            console.log(error);
        }
        return null;
    };
    const getIndexesSettings = async () => {
        try {
            let response;
            setLoading(true);
            if (isDemo) {
                response = (await import("src/scenes/indexes-settings/mock-data")).default;
            } else {
                response = await request(`/api/indexes/config`, { method: "GET" });
            }
            setIndexesOptedIn(response.optedIn);
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    React.useEffect(() => {
        getLatestSummary();
        getIndexesSettings();
    }, [activeIntegrations.status]);

    React.useEffect(() => {
        if (summaryData.createdAt === latestReadSummaryDate * 1) setIsPersonalSummaryVisible(false);
        if (summaryData.createdAt && !latestReadSummaryDate) setIsPersonalSummaryVisible(true);
    }, [summaryData]);

    return (
        <Grid container justifyContent="center" spacing={4} pt={2} className="tour-privacy">
            {isPersonalSummaryVisible && (
                <Grid item md={12}>
                    <PersonalSummary
                        setIsPersonalSummaryVisible={setIsPersonalSummaryVisible}
                        summaryData={summaryData}
                    />
                </Grid>
            )}
            <Grid item md={12} mb={6}>
                <QuestionsSection
                    isDemo={isDemo}
                    selectedQuestion={selectedQuestion}
                    setSelectedQuestion={setSelectedQuestion}
                    questions={questions}
                />
            </Grid>
            <Grid item md={12} mb={12}>
                {indexesOptedIn ? (
                    <IndexesSection OverviewApi={OverviewApi} isTeams={isTeams} />
                ) : (
                    <IndexesOptInPlaceholder isTeams={isTeams} loading={loading} />
                )}
            </Grid>
        </Grid>
    );
};

export default Insights;
